exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-enter-active{animation:flip-in .3s ease-out forwards}.flip-leave-active{animation:flip-out .3s ease-out forwards}@keyframes flip-out{0%{transform:rotateY(0deg)}to{transform:rotateY(90deg)}}@keyframes flip-in{0%{transform:rotateY(90deg)}to{transform:rotateY(0deg)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0adf7387","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 310
// module chunks = 0